import React, { useContext, useEffect, useState } from "react";
import backgroundImage from "./themeimg/dtLite/page_bg_image.jpg"
import headerImg from "./themeimg/dtLite/dream_travel_logo.png"
import banner from "./themeimg/dtLite/subscription_banner1-min.jpg"
import banner2 from "./themeimg/dtLite/subscription_banner2-min.jpg"
import { baseUrl, data, getHeaders } from '../config/config';
import axios from 'axios';
import { useLocation, useNavigate } from "react-router-dom";
import { SendGuiDataEvents } from "../CommonScript";
import LoaderComponent from './Loader';
import { Context } from "../Context/Context";
import circle from "./themeimg/dtLite/circle.png"
import check from "./themeimg/dtLite/checkcircle.png"

const Pack = () => {

  const navigate = useNavigate()
  const lang = localStorage.getItem("lang") || "fr"
  const [okClicked, setOkClicked] = useState(false)
  const location = useLocation()
  const { handlePageLoader, pageLoader } = useContext(Context)
  const type = sessionStorage.getItem("type")
  const [content, setContent] = useState()
  const [packType,setPackType] = useState()

  const getPacks = async () => {
    handlePageLoader(true)
    const response = await axios({
      method: 'post',
      url: baseUrl + 'getPacks',
      headers: {
        ...getHeaders(),
        "pack": type
      }
    })

    setContent(response?.data)
    // localStorage.setItem("packType", response?.data?.pack_type[0].pack)
    console.log(response?.data)
    handlePageLoader(false)
  }

  useEffect(() => {
    getPacks()
  }, [])

  const selectPack = (pack)=>{
    setPackType(pack)
    localStorage.setItem("packType", pack)
  }


  const handleButtonClick = () => {
   
      navigate("/subs", {
        state: { packText: content}
      })
    //  else {
    //   setOkClicked(true);
    // }
  };
  return (

    <div className="max-w-[500px] mx-auto min-h-[100vh] bg-[#FFCC00] pb-2"
    >
      {pageLoader && <LoaderComponent />}

      <div><img className="w-[65%] pt-2 mx-auto" src={headerImg} alt="header" /></div>
      <div className="theme-bg bg-cover bg-no-repeat">
        <div className="w-full mt-6 bg-[#FFCC00] relative">
          <img src={okClicked ? banner2 : banner} className="h-[50vh] w-[100%] mx-auto"></img>
          <div className="absolute bottom-8 w-full text-center text-white text-2xl">
            {/* {lang === "fr" ? "Bienvenue à Dream Travel" : "Welcome to Dream Travel"}
             */}
            {content?.title}
          </div>
          <div className="absolute bottom-8 sm:bottom-10 w-full text-center text-white text-3xl font-extrabold">
            {/* {lang === "fr" ? "vers une destination exotique" : "Mega Contest to an exotic destination"}
             */}
            {content?.subtitle}
          </div>
        </div>
        <div className="w-[80%]  text-black text-xl ml-8 mt-10 tracking-wide font-extrabold">
          {/* {okClicked ? (lang === "fr" ? "Pour confirmer la demande" : "To confirm the request") : (lang === "fr" ? "Cliquez sur OK pour vous abonner" : "Click OK to subscribe")}
           */}
          {okClicked ? content?.conf_title : content?.text}
        </div>
        {/* <div className="w-[80%]  text-black ml-8  mt-6 tracking-wide font-extrabold">
          {content?.pack_type[0]?.price}
        </div> */}

        {content && content?.pack_type.map((item)=>{
          return(
            <div key={item.id} className="border-2 border-black w-[80%] mx-auto py-2 text-black ml-8 tracking-wide font-extrabold mt-4 flex rounded-md justify-between px-1" onClick={()=>selectPack(item.pack)}>
              {item.price}
              <img src={packType === item.pack ? check : circle} className="w-6 h-6"></img>
            </div>
          )
        })}
        <div className="w-[80%]  text-black ml-8 mt-2 tracking-wide text-sm">
          {/* {lang === "fr" ? "*Des micro-frais peuvent s'appliquer" : "*Micro Changes may apply"} */}
          {content?.info}
        </div>
        <div className="mt-10 flex">
          <button className=" border-1 text-[#FFCC00] bg-black font-thin rounded-2xl w-[80%] justify-center mx-auto p-2" onClick={handleButtonClick}>
            {/* {lang === "fr" ? "D'accord" : "Ok"} */}
            {content?.btn_txt}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Pack